import {Label} from "@blueprintjs/core";
import {observer} from "mobx-react";
import React from "react";
import {useNavigate} from "react-router-dom";

import {formatToUtc} from "../../../utils/format-to-utc";
import {DeleteButton, EditButton} from "../../atoms/buttons/buttons";
import {
    ActionsColumn,
    FieldsColumn,
    HeaderGrid,
    LabelField,
    PageContainer,
} from "../../atoms/layouts/category-layout-containers";
import {Td, Tr} from "../../atoms/tables/table";
import CategoryLinkCell from "../../molecules/tables/category-link-cel";
import {AdminBreadcrumb} from "../../organisms/admin-breadcrumb/admin-breadcrumb";
import {DeleteDialog} from "../../organisms/delete-dialog/delete-dialog";
import {TableLayout} from "../../organisms/table-layout/table-layout";
import {AppLayout} from "../../templates/app-layout/app-layout";
import {CategoryGroupDetailPageStore} from "./category-group-detail-page-store";

const colums = [
    {
        label: "カテゴリ名",
        required: false,
    },
    {
        label: "識別子（Sllug）",
        width: 150,
        required: false,
    },
    {
        label: "作成日",
        width: 180,
        required: false,
    },
    {
        label: "関連ドキュメント",
        width: 150,
        required: false,
    },
];

export const CategoryGroupDetailPage: React.FC<{pageStore: CategoryGroupDetailPageStore}> =
    observer((props) => {
        const {mediaId, categoryGroupId, categoryGroup, confrmDeleteCategoryGroup} =
            props.pageStore;
        const navigate = useNavigate();

        return (
            <AppLayout
                breadcrumb={
                    <AdminBreadcrumb
                        factory={(builder) =>
                            builder.categoryGroups().custom(categoryGroup.label).build()
                        }
                    />
                }
                buttons={<></>}
            >
                <PageContainer>
                    <HeaderGrid>
                        <FieldsColumn area-label="カテゴリグループの詳細の表示">
                            <LabelField>
                                <Label>カテゴリグループ名</Label>
                                <span>{categoryGroup.label}</span>
                            </LabelField>
                            <LabelField>
                                <Label> 識別子（Slug）</Label>
                                <span>{categoryGroup.slug}</span>
                            </LabelField>
                        </FieldsColumn>
                        <ActionsColumn>
                            <EditButton
                                onClick={() =>
                                    navigate(
                                        `/admin/${mediaId}/category-groups/${categoryGroupId}/edit`,
                                    )
                                }
                            >
                                編集
                            </EditButton>
                            <DeleteButton onClick={() => confrmDeleteCategoryGroup()}>
                                削除
                            </DeleteButton>
                        </ActionsColumn>
                    </HeaderGrid>
                    <TableLayout areaLabel="カテゴリ詳細" columns={colums}>
                        {categoryGroup.categories.map(({slug, label, createdAt, count}) => (
                            <Tr key={slug}>
                                <Td>{label}</Td>
                                <Td>{slug}</Td>
                                <Td>{formatToUtc(createdAt!)}</Td>
                                {count && count > 0 ? (
                                    <CategoryLinkCell
                                        href={`/admin/${props.pageStore.mediaId}/documents?categoryGroup=${categoryGroup.slug}&category=${slug}`}
                                    >
                                        {count}
                                    </CategoryLinkCell>
                                ) : (
                                    <Td>{count}件</Td>
                                )}
                            </Tr>
                        ))}
                    </TableLayout>
                </PageContainer>
                <DeleteDialog />
            </AppLayout>
        );
    });
